// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Share on ${i.platform}`
};

const de_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Auf ${i.platform} teilen`
};

const es_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Compartir en ${i.platform}`
};

const fr_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Partager sur ${i.platform}`
};

const fi_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Jaa ${i.platform}:ssa`
};

const hi_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.platform} पर साझा करें`
};

const ja_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.platform}でシェア`
};

const nl_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Delen op ${i.platform}`
};

const pt_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Compartilhar no ${i.platform}`
};

const ro_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Partajează pe ${i.platform}`
};

const th_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `แชร์บน ${i.platform}`
};

const ur_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.platform} پر شیئر کریں`
};

const zh_hant1_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `在 ${i.platform} 上分享`
};

const da_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Del på ${i.platform}`
};

const it_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Condividi su ${i.platform}`
};

const vn_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Chia sẻ trên ${i.platform}`
};

const ko_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.platform}에서 공유하기`
};

const tr_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.platform}'da paylaş`
};

const lv_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Dalīties ${i.platform}`
};

const ar_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `شارك على ${i.platform}`
};

const bs_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Podijelite na ${i.platform}`
};

const sl_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Delite na ${i.platform}`
};

const id_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Bagikan di ${i.platform}`
};

const sv_widget_share_on_platform = /** @type {(inputs: { platform: NonNullable<unknown> }) => string} */ (i) => {
	return `Dela på ${i.platform}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ platform: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_share_on_platform = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_share_on_platform(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_share_on_platform", locale)
	if (locale === "en") return en_widget_share_on_platform(inputs)
	if (locale === "de") return de_widget_share_on_platform(inputs)
	if (locale === "es") return es_widget_share_on_platform(inputs)
	if (locale === "fr") return fr_widget_share_on_platform(inputs)
	if (locale === "fi") return fi_widget_share_on_platform(inputs)
	if (locale === "hi") return hi_widget_share_on_platform(inputs)
	if (locale === "ja") return ja_widget_share_on_platform(inputs)
	if (locale === "nl") return nl_widget_share_on_platform(inputs)
	if (locale === "pt") return pt_widget_share_on_platform(inputs)
	if (locale === "ro") return ro_widget_share_on_platform(inputs)
	if (locale === "th") return th_widget_share_on_platform(inputs)
	if (locale === "ur") return ur_widget_share_on_platform(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_share_on_platform(inputs)
	if (locale === "da") return da_widget_share_on_platform(inputs)
	if (locale === "it") return it_widget_share_on_platform(inputs)
	if (locale === "vn") return vn_widget_share_on_platform(inputs)
	if (locale === "ko") return ko_widget_share_on_platform(inputs)
	if (locale === "tr") return tr_widget_share_on_platform(inputs)
	if (locale === "lv") return lv_widget_share_on_platform(inputs)
	if (locale === "ar") return ar_widget_share_on_platform(inputs)
	if (locale === "bs") return bs_widget_share_on_platform(inputs)
	if (locale === "sl") return sl_widget_share_on_platform(inputs)
	if (locale === "id") return id_widget_share_on_platform(inputs)
	if (locale === "sv") return sv_widget_share_on_platform(inputs)
	return "widget_share_on_platform"
};